import * as React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { cartStore } from '../../cart'
import { IProduct } from '../product.interfaces'
import { ProductStates } from '../product.enums'
import { getFeatureFlag } from '../../../utils'
import './add-to-order.scss'

interface IProps {
  product: IProduct
}

const baseClass: string = 'add-to-order'

export const AddToOrder = observer((props: IProps): React.ReactElement => {
  const { product } = props
  const isMaintenanceModeEnabled = getFeatureFlag('isMaintenanceModeEnabled')

  const available = product.available
  const productId = product.id
  const inputQuantity = cartStore.getInputQuantityForProduct(productId)

  const canUpdateQuantity = (): boolean => {
    const item = cartStore.items.get(productId)
    return item ? item.quantity !== inputQuantity : inputQuantity > 0
  }

  const getProductState = (): ProductStates => {
    if (!available) {
      return ProductStates.OUT_OF_STOCK
    }

    const item = cartStore.items.get(productId)
    if (item) {
      if (item.quantity !== inputQuantity) {
        return ProductStates.QUANTITY_DID_UPDATE
      }
      return ProductStates.ADDED_TO_ORDER
    }
    return ProductStates.NOT_ADDED_TO_ORDER
  }

  const getButtonText = (): string => {
    const productState = getProductState()
    
    switch (productState) {
      case ProductStates.ADDED_TO_ORDER:
        return 'Added to cart'

      case ProductStates.NOT_ADDED_TO_ORDER:
        return 'Add to cart'

      case ProductStates.OUT_OF_STOCK:
        return 'Out of stock'

      case ProductStates.QUANTITY_DID_UPDATE:
        return 'Update quantity'
    }
  }

  const buttonProps: object = {
    'data-gtm-id': 'product-add-to-cart',
    className: classNames({
      [baseClass]: true,
      [`${baseClass}--disabled`]: !canUpdateQuantity() || isMaintenanceModeEnabled
    }),
    ...(available && !isMaintenanceModeEnabled ? { onClick: (): void => cartStore.updateOrAddItemToCart(product, inputQuantity) } : {})
  }

  return (
    <button type='submit' {...buttonProps}>
      {getButtonText()}
    </button>
  )
})
